import { apiClient } from './apiClient';

export interface PlantInfo {
  id: number;
  name: string;
  location: string;
  capacity_mw: number;
  slug: string;
  is_active: boolean;
}

export interface PlantPowerIrradianceData {
  timestamp: string;
  power_kw: number;
  irradiance_wm2: number;
}

export interface PlantPowerIrradianceResponse {
  plant_name: string;
  plant_id: number;
  data: PlantPowerIrradianceData[];
  correlation_coefficient: number;
  last_updated: string;
}

export interface PlantDailyExportData {
  date: string;
  total_export_kwh: number;
  total_energy_kwh: number;
  export_efficiency: number;
}

export interface PlantDailyExportResponse {
  plant_name: string;
  plant_id: number;
  data: PlantDailyExportData[];
  period: string;
  last_updated: string;
}

export interface PlantSummary {
  plant_name: string;
  plant_id: number;
  plant_location: string;
  plant_capacity_kw: number;
  current_power_kw: number;
  current_irradiance_wm2: number;
  today_energy_kwh: number;
  performance_ratio: number;
  last_updated: string;
}

export const plantApi = {
  // Get available plants
  getAvailablePlants: async (): Promise<{ plants: PlantInfo[]; total_count: number }> => {
    const response = await apiClient.get('/api/monitoring/plants/');
    return response.data;
  },

  // Get plant-specific power vs irradiance data
  getPlantPowerIrradiance: async (plantSlug: string, hours: number = 24): Promise<PlantPowerIrradianceResponse> => {
    const response = await apiClient.get(`/api/monitoring/plants/${plantSlug}/power-irradiance/?hours=${hours}`);
    return response.data;
  },

  // Get plant-specific daily export trends
  getPlantDailyExport: async (plantSlug: string, days: number = 7): Promise<PlantDailyExportResponse> => {
    const response = await apiClient.get(`/api/monitoring/plants/${plantSlug}/daily-export/?days=${days}`);
    return response.data;
  },

  // Get plant-specific dashboard summary
  getPlantSummary: async (plantSlug: string): Promise<PlantSummary> => {
    const response = await apiClient.get(`/api/monitoring/plants/${plantSlug}/summary/`);
    return response.data;
  }
};